import { Link } from 'react-router-dom'
import SeoHead from '../components/SeoHead'
import './NotFound.css'

const NotFound = () => {
  return (
    <div className="not-found-page">
      <SeoHead
        title="Page Not Found | SIBR Lifescience"
        description="The page you are looking for could not be found."
        noindex={true}
      />
      
      <div className="not-found-content">
        <div className="not-found-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
          </svg>
        </div>
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you're looking for doesn't exist or has been moved.</p>
        <div className="not-found-actions">
          <Link to="/" className="btn btn-primary">
            Go to Home
          </Link>
          <Link to="/products" className="btn btn-secondary">
            View Products
          </Link>
        </div>
      </div>
    </div>
  )
}

export default NotFound

